import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { useDialog } from "../../Dialogs/DialogProvider";
import AddModifierarticleDialog from "../Modifiergroups/AddModifierarticleDialog";
import withIntl from "../../../utils/withIntl";
import NewModifierarticleDialog from "../Modifiergroups/NewModifierarticleDialog";
import AuthorizationWrapper from "../../AuthorizationWrapper";

function ActionButtonModifiergroup(props) {
  const [openDialog] = useDialog();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenAddModifierarticlesDialog = (event) => {
    setAnchorEl(null);
    event.stopPropagation();
    openDialog({
      children: <AddModifierarticleDialog modifiergroup={props.modifiergroup} fullWidth={true} />,
      fullWidth: true,
      maxWidth: "xs",
      disableBackdropClick: true,
    });
  };

  const handleOpenNewModifierarticlesDialog = (event) => {
    setAnchorEl(null);
    event.stopPropagation();
    openDialog({
      children: <NewModifierarticleDialog modifiergroup={props.modifiergroup} fullWidth={true} />,
      fullWidth: true,
      maxWidth: "sm",
      disableBackdropClick: true,
    });
  };

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
      <AuthorizationWrapper
        permission={"add_modifierarticle"}
        child={
          <IconButton
            style={{ marginRight: 40 }}
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
            variant="standard"
          >
            <BuildIcon colo={"primary"} />
          </IconButton>
        }
      />

      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={handleOpenNewModifierarticlesDialog}>
          <AddIcon color={"primary"} />
          {props.intl.formatMessage({ id: "create_new_modifierarticle" })}
        </MenuItem>
        <MenuItem onClick={handleOpenAddModifierarticlesDialog}>
          <AddIcon color={"primary"} />
          {props.intl.formatMessage({ id: "add_existing_modifierarticle" })}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonModifiergroup);
